export default class BusinessDetails {
	constructor($module) {
		this.$module = $module;
		this.$lookupInput = this.$module.querySelector("#BusinessAddressLookup");
		this.$manualToggle = this.$module.querySelector(
			".ip-business-details__manual-address-toggle"
		);
		this.$addressFields = this.$module.querySelector(
			".ip-business-details__address-fields"
		);

		if (!this.$lookupInput || !this.$addressFields) {
			return;
		}

		this.$fieldMap = {
			line1: this.$module.querySelector("#AddressLine1"),
			line2: this.$module.querySelector("#AddressLine2"),
			city: this.$module.querySelector("#City"),
			county: this.$module.querySelector("#County"),
			country: this.$module.querySelector("#Country"),
			postcode: this.$module.querySelector("#Postcode"),
		};

		this.bindManualToggle();
		this.bindLookupActions();
		this.bindExternalLookupEvent();
		this.setAddressFieldsEnabled(false);
	}

	bindManualToggle() {
		if (!this.$manualToggle) {
			return;
		}

		this.$manualToggle.addEventListener("click", (event) => {
			event.preventDefault();
			this.showAddressFields();
		});
	}

	bindLookupActions() {
		this.$lookupInput.addEventListener("keydown", (event) => {
			if (event.key !== "Enter") {
				return;
			}

			event.preventDefault();
			this.populateFromLookup(this.$lookupInput.value);
		});

		this.$lookupInput.addEventListener("change", () => {
			if (!this.$lookupInput.value.trim()) {
				return;
			}

			this.populateFromLookup(this.$lookupInput.value);
		});
	}

	bindExternalLookupEvent() {
		this.$module.addEventListener("ip:business-address-selected", (event) => {
			if (!event.detail) {
				return;
			}

			this.applyAddress(event.detail);
			this.showAddressFields();
		});
	}

	showAddressFields() {
		this.$addressFields.hidden = false;
		this.setAddressFieldsEnabled(true);
	}

	setAddressFieldsEnabled(isEnabled) {
		this.$addressFields.querySelectorAll("input, select").forEach((field) => {
			field.disabled = !isEnabled;
		});
	}

	applyAddress(address) {
		const mapping = [
			["line1", "line1"],
			["line2", "line2"],
			["city", "city"],
			["county", "county"],
			["postcode", "postcode"],
		];

		mapping.forEach(([detailKey, fieldKey]) => {
			const input = this.$fieldMap[fieldKey];
			if (!input || typeof address[detailKey] !== "string") {
				return;
			}

			input.value = address[detailKey];
		});

		if (typeof address.country === "string" && this.$fieldMap.country) {
			const targetCountry = address.country.toLowerCase();
			const countryOptions = Array.from(this.$fieldMap.country.options);
			const foundOption = countryOptions.find((option) =>
				option.text.toLowerCase().includes(targetCountry)
			);

			if (foundOption) {
				this.$fieldMap.country.value = foundOption.value;
			}
		}
	}

	populateFromLookup(lookupValue) {
		const parsedAddress = this.parseAddress(lookupValue);
		this.applyAddress(parsedAddress);
		this.showAddressFields();
	}

	parseAddress(rawValue) {
		const value = rawValue.trim();
		if (!value) {
			return {};
		}

		const parts = value
			.split(",")
			.map((part) => part.trim())
			.filter(Boolean);

		const country = parts.length ? parts[parts.length - 1] : "";
		const city = parts.length > 1 ? parts[parts.length - 2] : "";
		const line1Parts =
			parts.length > 2 ? parts.slice(0, parts.length - 2) : [parts[0] || ""];
		const line1 = line1Parts.join(", ");

		const postcodeMatch = value.match(
			/\b([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}|[A-Z]\d{2}\s*[A-Z\d]{4})\b/i
		);

		return {
			line1,
			city,
			country,
			postcode: postcodeMatch ? postcodeMatch[0].trim() : "",
		};
	}
}
